import { render } from "./VSingleTreatment.vue?vue&type=template&id=e1352096"
import script from "./VSingleTreatment.vue?vue&type=script&lang=js"
export * from "./VSingleTreatment.vue?vue&type=script&lang=js"

import exportComponent from "/apps/releases/202604221556/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/platform/components/offline-booking/VSingleTreatment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e1352096"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e1352096', __exports__)) {
    api.reload('e1352096', __exports__)
  }
  
  module.hot.accept("./VSingleTreatment.vue?vue&type=template&id=e1352096", () => {
    api.rerender('e1352096', render)
  })

}


export default __exports__